import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

import { KakaotalkTemplatesService } from 'src/app/parameters/message-templates/kakaotalk-templates/kakaotalk-templates.service';
import { KakaotalkTemplateButtonTypeEnum } from 'src/app/parameters/message-templates/kakaotalk-templates/shared';
import { KakaotalkTemplateButton } from 'src/app/parameters/message-templates/kakaotalk-templates/shared/models/kakaotalk-template-button.model';
import { UploadService } from '../../../../services/upload.service';

@Component({
  selector: 'app-kakaotalk-template-preview',
  templateUrl: './kakaotalk-template-preview.component.html',
  styleUrls: ['./kakaotalk-template-preview.component.scss'],
})
export class KakaotalkTemplatePreviewComponent implements OnInit, OnDestroy {
  @Input() settingsMode: boolean;
  @Input() templateDisplayedBS: BehaviorSubject<FormGroup> = new BehaviorSubject(null);

  templateForm: FormGroup;

  imageSrc!: any;
  header: any;
  bodyFormatted: string;
  /**
   * The complete list of buttons to display.
   */
  buttons: KakaotalkTemplateButton[];
  subscriptions: Subscription = new Subscription();
  templateFormChangeSubscription: Subscription = new Subscription();

  KakaotalkTemplateButtonTypeEnum = KakaotalkTemplateButtonTypeEnum;

  constructor(private kakaotalkTemplatesService: KakaotalkTemplatesService, private uploadService: UploadService) {}

  ngOnInit(): void {
    if (this.settingsMode) {
      this.subscriptions.add(
        this.kakaotalkTemplatesService.headerMediaFileBS.subscribe(result => {
          this.imageSrc = null;
          if (result) {
            const { media_url, media_id } = result;
            let mediaUrl = media_url;
            if (!media_url && media_id) {
              mediaUrl = this.getMediaUrlFromMediaId(media_id);
            }
            this.imageSrc = mediaUrl;
          }
        })
      );
    }
    this.subscriptions.add(
      this.templateDisplayedBS.pipe(throttleTime(100)).subscribe(value => {
        if (value) {
          this.templateFormChangeSubscription?.unsubscribe();
          this.templateForm = value;
          this.formatTemplate();
          this.templateFormChangeSubscription.add(
            this.templateForm.valueChanges.subscribe({
              next: () => this.formatTemplate(),
            })
          );
        }
      })
    );
  }

  private formatTemplate() {
    const { header, body, buttons, placeholders } = this.templateForm.getRawValue();
    this.formatHeader(header);
    this.formatBody(placeholders, body);
    this.buttons = (buttons || []).map((button: KakaotalkTemplateButton) => {
      const { text, url, example } = button;
      const urlFormatted = example && url ? url.replace('{{1}}', example as string) : url;
      return { text, url: urlFormatted };
    });
  }

  private formatHeader(header) {
    this.imageSrc = null;
    if (header && (header.media_id || header.media_url)) {
      const { media_id, media_url } = header;
      this.header = header;
      let mediaUrl = media_url;
      if (!media_url && media_id) {
        mediaUrl = this.getMediaUrlFromMediaId(media_id);
      }
      this.imageSrc = mediaUrl;
    }
  }

  private getMediaUrlFromMediaId(media_id: number) {
    return this.uploadService.pictureUrl(media_id);
  }

  private formatBody(placeholders, body) {
    const placeholderKeys = Object.keys(placeholders || {});
    if (placeholderKeys?.length && body) {
      this.bodyFormatted = placeholderKeys.reduce(
        (bodyFormatted, placeholder) =>
          bodyFormatted.replace(placeholder, placeholders[placeholder]?.example || placeholders[placeholder]?.label),
        body
      );
    } else {
      this.bodyFormatted = body;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
    this.templateFormChangeSubscription?.unsubscribe();
  }
}
